var _path, _path2, _circle, _circle2, _line;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMissingFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 120,
    viewBox: "0 0 100 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10 H60 L80 30 V100 H20 Z",
    stroke: "#808080",
    strokeWidth: 3,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 10 V30 H80",
    stroke: "#808080",
    strokeWidth: 3,
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 50,
    r: 4,
    fill: "#808080"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 50,
    r: 4,
    fill: "#808080"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 70,
    x2: 65,
    y2: 70,
    stroke: "#808080",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissingFile);
export default __webpack_public_path__ + "static/media/missingFile.f734658ad895cf3fac6052129e05858f.svg";
export { ForwardRef as ReactComponent };